// 1. Personal Pronouns / Subject Pronouns
// 2. Object Pronouns
// 3. Possessive Pronouns
// 4. Reflexive Pronouns

export const pronounsObject = {
  i: 1,
  we: 1,
  you: 1,
  he: 1,
  she: 1,
  it: 1,
  they: 1,
  me: 1,
  us: 1,
  her: 1,
  him: 1,
  them: 1,
  mine: 1,
  ours: 1,
  yours: 1,
  hers: 1,
  his: 1,
  theirs: 1,
  myself: 1,
  yourself: 1,
  herself: 1,
  himself: 1,
  itself: 1,
  ourselves: 1,
  yourselves: 1,
  themselves: 1,
};
